import { action } from '../../../lib/api';

export const setLookupLoading = (id, value) => {
  action('SET_LOOKUP_LOADING', { [id]: value });
};
